import LoginForm from '../components/LoginForm'
import BotImage from '@/assets/bot-login.webp'
import Logo from '@/assets/logo.webp'
import { Column, Row, Text } from '@/components/core'

const Login: React.FC = () => {
  return (
    <Row className="min-h-screen w-full overflow-hidden">
      <Column className="w-full bg-white px-18 py-22 max-md:px-10 md:min-w-[330px] md:max-w-[560px]">
        <img src={Logo} alt="FluencyFlow" width={56} height={56} />
        <Text.Translated
          className="mb-12 mt-5 text-xl font-bold text-gray-600"
          translationKey="app_name_login"
        />
        <LoginForm />
      </Column>
      <Column className="w-full items-center justify-center max-md:hidden">
        <img
          src={BotImage}
          alt="Bot Image"
          className="h-auto w-[70%] max-w-[648px]"
        />
        <Row className="mt-5 w-full justify-center text-center">
          <Text.Translated
            className="text-white"
            translationKey="simple_engaging_fluency_test_login"
          />
        </Row>
        <Row className="w-full justify-center text-center">
          <Text.Translated
            className="text-white"
            translationKey="we_make_it_easier_login"
          />
        </Row>
      </Column>
    </Row>
  )
}

export default Login
